declare var Swiper: any;

const $window = $(window);
const $cardSlider = $('.js-card-slider');
let swiper: {
  params: { slidesPerView: string },
  slideNext: Function,
  slidePrev: Function,
};

const cardSlider = {
  initialize() {
    if (!$cardSlider.length) {
      return;
    }

    if (typeof Swiper === 'undefined') {
      throw new Error('You should add Swiper before using the card slider');
    }

    swiper = new Swiper($cardSlider.find('.swiper-container')[0], {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: this.getNumberOfSlides(),
      initialSlide: 2,
      loop: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 50,
        depth: 200,
        modifier: 1,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.js-swiper-next',
        prevEl: '.js-swiper-prev',
      },
    });

    $window.on('resize', () => {
      this.updateSwiper();
    });
  },

  getNumberOfSlides() {
    if ($window.width() >= 1200) {
      return '3';
    // tslint:disable-next-line
    } else if ($window.width() >= 992) {
      return '2.5';
    // tslint:disable-next-line
    } else if ($window.width() >= 768) {
      return '2.25';
    // tslint:disable-next-line
    } else if ($window.width() >= 370) {
      return '1.5';
    }

    return '1.2';
  },

  updateSwiper() {
    swiper.params.slidesPerView = this.getNumberOfSlides();
  },
};

export default cardSlider;
